import { ChangeDetectionStrategy, Component, inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  AppRoutes,
  AppVersion,
  AuthRoutes,
  BuildVersion,
  ENV_CONFIG,
  EnvConfig,
  FindGamesRoutes,
  PLATFORM_TOKEN,
  PlatformProvider
} from '@core';
import { take } from 'rxjs';
import { AuthHeaderComponent } from '../../components';
import { AuthWithProviderCommandHandler } from '../../application/handlers';
import { redirectAfterLoginUtil } from '../../application/utils';
import { SplashScreen } from '@capacitor/splash-screen';

@Component({
  templateUrl: './auth-home.page.html',
  styleUrls: ['./auth-home.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AuthHeaderComponent]
})
export class AuthHomePage implements OnInit {
  private readonly router: Router = inject(Router);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly authWithProviderCommandHandler: AuthWithProviderCommandHandler =
    inject(AuthWithProviderCommandHandler);
  private readonly injector: Injector = inject(Injector);
  private readonly env: EnvConfig = inject(ENV_CONFIG);

  readonly appVersion: string = AppVersion;
  readonly buildVersion: string = BuildVersion;
  readonly isAndroid: boolean = this.platformProvider.isAndroid;

  ngOnInit(): void {
    SplashScreen.hide();
  }

  goToLogin(): void {
    this.router.navigate([`/${AppRoutes.AUTH}/${AuthRoutes.LOGIN}`]);
  }

  goToRegister(): void {
    this.router.navigate([`/${AppRoutes.AUTH}/${AuthRoutes.REGISTER}`]);
  }

  goToMap(): void {
    this.router.navigate([`${AppRoutes.FIND_GAMES}/${FindGamesRoutes.MAP}`]);
  }

  googleAuth(): void {
    this.authWithProviderCommandHandler
      .authWithGoogle()
      .pipe(take(1))
      .subscribe(() => redirectAfterLoginUtil(this.injector));
  }

  appleAuth(): void {
    this.authWithProviderCommandHandler
      .authWithApple()
      .pipe(take(1))
      .subscribe(() => redirectAfterLoginUtil(this.injector));
  }

  facebookAuth(): void {
    if (!this.env.production) return;

    this.authWithProviderCommandHandler
      .authWithFacebook()
      .pipe(take(1))
      .subscribe(() => redirectAfterLoginUtil(this.injector));
  }

  getTermsOfService(): void {
    window.open(
      'https://firebasestorage.googleapis.com/v0/b/orlikfy-infra-prod.appspot.com/o/docs%2FOrlikfy%20Regulamin.pdf?alt=media&token=337ce6fa-1b40-4ed9-a89d-4a917d332e91'
    );
  }

  getPolicyPrivacy(): void {
    window.open(
      'https://firebasestorage.googleapis.com/v0/b/orlikfy-infra-prod.appspot.com/o/docs%2FOrlikfy%20Polityka%20Prywatnosci.pdf?alt=media&token=ad93ba59-a2ef-445e-b4d2-5d75da613b9f'
    );
  }
}
